var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "11px",
    height: "6px",
    viewBox: "0 0 11 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Home ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.50316638,6 C5.66148532,6 5.81980426,5.93865031 5.92746114,5.82208589 L10.8290155,0.957055215 C10.9366724,0.852760736 11,0.717791411 11,0.564417178 C11,0.245398773 10.7530225,0 10.4237191,0 C10.2654001,0 10.1197467,0.0613496933 10.0120898,0.159509202 L5.50316638,4.62576687 L0.98791019,0.159509202 C0.886586068,0.0613496933 0.740932642,0 0.576280944,0 C0.246977547,0 0,0.245398773 0,0.564417178 C0,0.717791411 0.0633275763,0.852760736 0.170984456,0.963190184 L5.07253886,5.82208589 C5.19286126,5.93865031 5.33851468,6 5.50316638,6 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Multiple-Account-Experience",
    transform: "translate(-309.000000, -225.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(131.000000, 140.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(3.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bars/Navigation-bar-Copy",
    transform: "translate(4.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(164.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon.Secondary",
    transform: "translate(7.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#4b4b4b",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.000000, -9.000000)",
    id: "Icon.Secondary"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    fill: "#4b4b4b",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.af43232ee72c1b00ebe8b375647cdc3c.svg";
export { ForwardRef as ReactComponent };